export default "../static/assets/logo-f85fdd6972a827124b5ed7f6499e68f6.png";